module.exports = __webpack_public_path__ + "static/media/instructivooc1.d93f8cba.png";